/* eslint-disable arrow-body-style */
import { Modal } from '@mui/material';
import { StyledModalBox } from '../../blogs/styles';
import EventNewEditForm from 'src/sections/@dashboard/event/EventNewEditForm';
import { Event } from '../../../../@types/event';

type EventModalProps = {
  open: boolean;
  handleClose(): void;
  isEdit: boolean;
  currentEvent: Event | undefined;
};

export const EventModal = ({ open, handleClose, isEdit, currentEvent }: EventModalProps) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledModalBox>
        <EventNewEditForm
          handleClose={handleClose}
          isEdit={isEdit}
          currentEvent={currentEvent}
        />
      </StyledModalBox>
    </Modal>
  );
};
